<a (click)="onFacebookLoginClick()">
    <i class="fa fa-facebook"></i> 
    <span *ngIf="this.isShowText && this.isProfile  && !this.isSignUp">Link to Facebook </span>
    <span *ngIf="this.isShowText && !this.isProfile && !this.isSignUp">Sign In With Facebook </span>
    <span *ngIf="this.isShowText && this.isSignUp && !this.isProfile">Continue With Facebook </span>
</a>